import { IconActivity, IconGift, IconGlobe, IconHelpCircle, IconInfo, IconMessageSquare } from 'featherico';
import moment from 'moment-timezone';
import api from '../../../../../api';
import { Dropdown, OptionLink, OptionWithModal, createLinkOption } from '../../../../components/Dropdown';
import NotificationsDotButton from '../../../../components/Notifications/Dot/Button';
import NotificationsDotInline from '../../../../components/Notifications/Dot/Inline';
import { useAppContext } from '../../../../hooks/useAppContext';
import { useObservable } from '../../../../hooks/useObservable';
import { isAnyAdmin } from '../../../../services/User';
import IntercomSupportLink from '../../../Navigation/SupportLink/IntercomSupportLink';
import { HrListSupport } from '../../../Navigation/SupportLink/WithHrListSupportModal';

const OptionHelpLink = createLinkOption((props: { onClick?: () => void }) => <IntercomSupportLink {...props} />);

export default function HelpMenu() {
    const { user: currentUser } = useAppContext();

    const { value: lastUpdatedReleaseNotes } = useObservable(
        () => api.releaseNotes.getLastUpdatedReleaseNotes.createObservable(),
        []
    );

    const newReleaseNotes =
        lastUpdatedReleaseNotes &&
        moment(currentUser.lastCheckedReleaseNotes ?? currentUser.dateCreated).isBefore(lastUpdatedReleaseNotes?.date);

    return (
        <Dropdown
            kind="PLAIN"
            showChevron={false}
            ariaLabel={`Help menu`}
            label={
                <>
                    <IconHelpCircle />
                    {newReleaseNotes && <NotificationsDotButton />}
                </>
            }
            eventTracking={{ category: 'navigation header help', action: 'toggle' }}
            large={true}
            className="top-aligned left-aligned"
        >
            <OptionLink
                href="https://intercomdocs.small-improvements.com/en/"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'help center' }}
            >
                <IconInfo /> Help Center
            </OptionLink>
            {isAnyAdmin(currentUser) ? (
                <OptionHelpLink />
            ) : (
                <OptionWithModal
                    modalProps={{
                        size: 'LG_WIDTH',
                        title: 'Get Support',
                        body: () => <HrListSupport />,
                    }}
                    eventTracking={{
                        category: 'navigation header help',
                        action: 'click',
                        label: 'get help non-admin',
                    }}
                >
                    <IconMessageSquare /> Get Support
                </OptionWithModal>
            )}
            <OptionLink
                href="https://www.small-improvements.com/release-notes"
                onClick={() => api.userSettings.setCheckedReleaseNotes()}
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'whats new' }}
            >
                <IconGift /> What's New
                {newReleaseNotes && <NotificationsDotInline />}
            </OptionLink>
            <OptionLink
                href="https://status.small-improvements.com"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'system status' }}
            >
                <IconActivity /> System Status
            </OptionLink>
            <OptionLink
                href="https://small-improvements.com"
                openInNewTab={true}
                eventTracking={{ category: 'navigation header help', action: 'click', label: 'si home page' }}
            >
                <IconGlobe /> Website
            </OptionLink>
        </Dropdown>
    );
}
